import PropTypes from 'prop-types';
import { createPortal } from 'react-dom';
import { Tooltip } from 'react-tooltip';
import classname from 'classnames';


const TooltipComponent= ({
	id,
	content,
	render,
	placement = 'bottom-start',
	offset = 0,
	disabled = false,
	dataTestId = 'tooltip',
	portal = false, // ← default false
	children,
	fullWidth= false,
}) => {
	const toolTipId = id || content || 'tooltip';

	const tooltipElement = !disabled && <Tooltip id={toolTipId} className="DS__tooltip-box" opacity={1} place={placement} offset={offset} noArrow {...(render ? { render } : {})} />;

	const toolTipClass = classname({
		'DS__tooltip-wrapper': true,
		'DS__tooltip-wrapper--full-width': fullWidth,
	});

	return (
		<div className={toolTipClass}>
			<span data-tooltip-id={toolTipId} data-tooltip-content={!render ? content : undefined} data-testid={`tooltip-${dataTestId}`}>
				{children}
			</span>

			{!disabled && (portal ? createPortal(tooltipElement, document.body) : tooltipElement)}
		</div>
	);
};

export default TooltipComponent;

TooltipComponent.propTypes = {
	id: PropTypes.string,
	content: PropTypes.string.isRequired,
	render: PropTypes.func,
	placement: PropTypes.oneOf([
		'top', 'top-start', 'top-end',
		'bottom', 'bottom-start', 'bottom-end',
		'left', 'left-start', 'left-end',
		'right', 'right-start', 'right-end'
	]),
	offset: PropTypes.number,
	children: PropTypes.node.isRequired,
	disabled: PropTypes.bool,
	dataTestId: PropTypes.string,
	portal: PropTypes.bool,
	fullWidth: PropTypes.bool,
};
